import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import styles from "./index.module.css";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";

import * as ajax from "helpers/ajax";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import ProgressBar from "@ramonak/react-progress-bar";
import { toPercentage, calculateSAL, calculateSALHierarchical, toPrice, calculateImportoContrattuale } from "helpers/functions.js"
import DettaglioCommessa from "../commessa/recapCommessa.js"
import SALCommessa from "../commessa/sal.js"
import SALCommessaQuadro from "../commessa/salQuadro.js"

import html2pdf from 'html2pdf.js'



export default class SAL extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            openCommessa: null,
            search:"",
            openIncarichi: null
        };
        this.csv = [[]];
    }

    componentDidMount = () => {
        this.load()
    }

    load = () => {
        ajax.ajaxGetStrapi("commessas?populate=gara&populate=fattures&populate=preventivis&filters[stato][$ne]=finito&filters[commessa_madre]&populate=commessa_madre&populate=incarichi.*&populate=incarichi.commessa_madre&populate=incarichi.fattures",this.loadCallback)
    }

    loadCallback = (response) => {
        response.data.map((el) => {
            el["sal"] = [];
            el.incarichi.map((incarico) => {
                incarico["sal"] = []
            })
        })
        this.setState({ data: response.data, openCommessa:null, openIncarichi:null }, this.loadSAL)
    }

    loadSAL = () => {
        ajax.ajaxGetStrapi("sal-commessas?populate=commessa&populate=parent", this.loadSALCallback)
    }

    loadSALCallback = (response) => {
        let data = this.state.data

        response.data.map((el) => {
            if (!el.commessa) {return}
            for (let i = 0; i < data.length; i++) {
                if (data[i].id == el.commessa.id) {
                    data[i].sal.push(el);
                    return;
                }
                data[i].incarichi.map((incarico, index) => {
                    if (incarico.id == el.commessa.id) {
                        data[i].incarichi[index].sal.push(el)                        
                    }
                })
            }
        })
        
        // Don't organize here - let the global function handle it
        this.setState({data:data})
    }

    calculateSalQuadro = (data) => {
        let totalIncidenza = 0;
        let totalWeightedPercentage = 0;

        // First calculate total incidenza
        data.forEach((el) => {
            if (!el.sal) { el.sal = [] }
            if (!el.incidenza) { el.incidenza = 0 }
            totalIncidenza += parseFloat(el.incidenza) || 0;
        });

        // Calculate weighted average with normalization
        data.forEach((el) => {
            const incidenza = parseFloat(el.incidenza) || 0;
            const salPercentage = calculateSALHierarchical(el.sal);
            
            // Normalize incidenza to percentage of total
            const normalizedIncidenza = totalIncidenza > 0 ? (incidenza / totalIncidenza) * 100 : 0;
            
            totalWeightedPercentage += (salPercentage * normalizedIncidenza / 100);
        });

        return totalWeightedPercentage;
    }


    renderSAL = (el, index) => {
        let importoContrattuale = calculateImportoContrattuale(el, false)

        let sal = calculateSALHierarchical(el.sal);
        
        let importoFatturato = 0;
        el.fattures.map((fatt) => {
            importoFatturato += (fatt.imponibile * (1 + (fatt.iva / 100)))
        })

        if (el.incarichi.length > 0) {
            importoContrattuale = 0;
            importoFatturato = 0;
            el.incarichi.map((incarico) => {
                importoContrattuale += incarico.preventivo
                incarico.fattures.map((fatt) => {
                    importoFatturato += (fatt.imponibile * (1 + (fatt.iva / 100)))
                })
            })
            sal = this.calculateSalQuadro(el.incarichi);
        }

        this.csvAdd(index + 1, el.nome)
        this.csvAdd(index + 1, toPercentage(sal))
        this.csvAdd(index + 1, toPrice(importoContrattuale))
        this.csvAdd(index + 1, toPrice(importoContrattuale * sal / 100))
        this.csvAdd(index + 1, toPrice(importoFatturato))
        this.csvAdd(index + 1, toPrice(importoContrattuale - importoFatturato))

        return (
            <Grid container alignItems="center" key={"sal-" + index}  sx={{ borderBottom: "1px solid #00000080", marginBottom: "10px", paddingBottom: "10px" }}>
                <Grid item sm={2} >
                    <MDTypography variant="button" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{el.nome}</MDTypography>
                </Grid>

                <Grid item sm={4} mr={1}>
                    {
                        this.renderProgressBar(sal)
                    }
                </Grid>

                <Grid item sm={1} mr={1}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale*sal/100)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoFatturato)}</MDTypography>
                </Grid>
                <Grid item sm={1} mr={1}>
                    <MDTypography variant="caption" sx={{ textDecoration: (el.completed) ? 'line-through' : 'none' }}>{toPrice(importoContrattuale-importoFatturato)}</MDTypography>
                </Grid>


                <Grid item mr={1} className="d-print-none">
                    <MDButton variant="text" color="info"
                        onClick={() => {
                            if (el.incarichi.length>0) {
                                this.setState({ openIncarichi: JSON.parse(JSON.stringify(this.state.data[index])) })
                            }
                            else {
                                this.setState({ openCommessa: JSON.parse(JSON.stringify(this.state.data[index])) })
                            }
                        }}>
                        Dettagli {">"}
                    </MDButton>
                </Grid>
            </Grid>
        )
    }

    renderProgressBar = (percentage) => {
        return (
            <ProgressBar className={styles.progressBar} completed={percentage} customLabel={toPercentage(percentage)} />
            )
    }


    csvAdd = (i, v) => {
        if (!this.csv[i]) { this.csv[i] = [] }
        if (v == null) { v = "" }
        this.csv[i].push(v)
    }



    print = () => {
        window.print();
    }

    download = () => {
        var element = document.getElementById('print-table');
        var opt = {
            margin: 1,
            filename: "sal.pdf",
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
            pagebreak: { mode: 'avoid-all' ,before: ['.page-break'] }
        };


        html2pdf(element,opt);
    }




    downloadCSVFile = () => {
        var output = "";
        this.csv.forEach((o, i) => {
            o.forEach((p, j) => {
                output += `"${p}"`;
                if (j < o.length - 1) {
                    output += ",";
                }
            });
            output += "\n";
        });
        let csvData = output;
        let a: any = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        let blob = new Blob([csvData], { type: 'text/csv' });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'sal.csv';
        a.click();

        return output;

    }


    render() {

        {/*
        if (this.state.openCommessa) {
            return <DettaglioCommessa data={this.state.openCommessa} backFunction={() => this.load()} />
        }
        */}

        if (this.state.openCommessa) {
            return <SALCommessa data={this.state.openCommessa} backFunction={() => { this.load() }} />
        }

        if (this.state.openIncarichi) {
            return <SALCommessaQuadro data={this.state.openIncarichi} backFunction={() => { this.load() }} />
        }


        {this.csv=[[]]}
        {
            this.csvAdd(0, "Commessa")
            this.csvAdd(0, "Avanzamento Lavori")
            this.csvAdd(0, "Importo Contrattuale")
            this.csvAdd(0, "Importo Avanzamento")
            this.csvAdd(0, "Importo Fatturato")
            this.csvAdd(0, "Rimanenza Da Fatturare")
        }

        return (
            <DashboardLayout>
                <div className="d-print-none">
                <DashboardNavbar />
            
                <PageTitle
                    text={"SAL"}
                    menu={[{ label: "Stampa", function: this.print },  { label: "Scarica CSV", function: this.downloadCSVFile }]}
                />

                <Grid container mt={3}>
                    <Grid item sm={8}>
                        <MDTypography variant="h3" textTransform="uppercase">Commesse</MDTypography>
                    </Grid>
                    <Grid item sm={4} container justifyContent="flex-end">
                        <MDInput
                        value={this.state.search}
                        onChange={(e) => this.setState({ search: e.target.value })}
                        placeholder="Cerca"
                        />
                    </Grid>
                </Grid>
                </div>

                <Grid mt={5} id="print-table">
                    <Grid container>
                        <Grid item sm={2} >
                            <MDTypography variant="button" textTransform="uppercase">Commesse</MDTypography>
                        </Grid>

                        <Grid item sm={4} mr={1}>
                            <MDTypography variant="button" textTransform="uppercase">Avanzamento Lavori</MDTypography>
                        </Grid>

                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button" textTransform="uppercase">Importo Contrattuale</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button" textTransform="uppercase">Importo Avanzamento</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1}>
                            <MDTypography variant="button" textTransform="uppercase">Importo Fatturato</MDTypography>
                        </Grid>
                        <Grid item sm={1} mr={1}>
                            <MDTypography  variant="button" textTransform="uppercase">Rimanenza Da Fatturare</MDTypography>
                        </Grid>

                        <Grid item sm={1} className="d-print-none"></Grid>
                    </Grid>
                    {this.state.data.map((el, index) => {
                        if (el.nome.toLowerCase().includes(this.state.search.toLowerCase())){
                            return this.renderSAL(el, index);
                        }
                    })}
                </Grid>
            </DashboardLayout>
        )
    }
}


